<label class="adc-toggle-rounded" [class]="data.disabled && 'disabled'" ngClass="{{ data.customClass }}">
    <input type="checkbox" [checked]="data.checked" [disabled]="data.disabled" (change)="checkboxEvent($event)">
    <span></span>
</label>

<!-- <label class="adc-toggle" [class]="data.disabled && 'disabled'" *ngIf="type=='square'" ngClass="{{ data.customClass }}">
    <input type="checkbox" [checked]="data.checked" [disabled]="data.disabled">
    <span></span>
</label> -->